"use client";
import React from "react";

type Props = {
  content: React.ReactNode;
};

const Content = ({ content }: Props) => {
  return (
    <>
      <section id="content" className="scroll-mt-30">
        <div className="overflow-hidden relative pb-20 pt-5 lg:pt-20 bg-[#f3f4f6]">
          <div className="max-w-[1170px] w-full mx-auto px-4 sm:px-8 xl:px-0">
            {content}
          </div>
        </div>
      </section>
    </>
  );
};

export default Content;